/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Not_Enough_Stamps_GuideInputs */

const en_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open more cake boxes to earn stamps from duplicate cakes, or get the Boosting Pack for an instant top-up!`)
};

const ar_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح المزيد من صناديق الكيك لكسب الطوابع من الكعك المكرر، أو احصل على باقة التعزيز لزيادة رصيدك فورًا!`)
};

const de_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffne mehr Kuchenboxen, um Stempel aus doppelten Kuchen zu verdienen, oder hol dir das Boost-Paket für ein sofortiges Aufladen!`)
};

const es_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Abre más cajas de pasteles para ganar sellos de los pasteles repetidos, o consigue el Paquete de Impulso para una recarga instantánea!`)
};

const fr_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrez plus de boîtes à gâteaux pour gagner des timbres grâce aux gâteaux en double, ou obtenez le pack de boost pour une recharge instantanée !`)
};

const it_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri più scatole di torte per guadagnare bollini dalle torte doppie, o ottieni il Pacchetto Boost per una ricarica istantanea!`)
};

const ja_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もっとケーキボックスを開けて重複したケーキからスタンプを獲得するか、ブーストパックを入手してすぐにチャージしましょう！`)
};

const ko_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`더 많은 케이크 상자를 열어 중복 케이크에서 스탬프를 얻거나, 부스트 팩을 구매해 즉시 충전하세요!`)
};

const pt_br_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra mais caixas de bolo para ganhar selos com bolos repetidos ou adquira o Pacote de Impulso para uma recarga instantânea!`)
};

const ru_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открывайте больше коробок с тортами, чтобы получать штампы за повторяющиеся торты, или приобретите набор для ускорения, чтобы мгновенно пополнить счет!`)
};

const th_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เปิดกล่องเค้กเพิ่มเติมเพื่อรับแสตมป์จากเค้กที่ซ้ำกัน หรือรับแพ็กบูสต์เพื่อเติมพลังทันที!`)
};

const tr_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekrar eden pastalardan pul kazanmak için daha fazla pasta kutusu aç veya anında yükleme yapmak için Takviye Paketi'ni al!`)
};

const zh_cn_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从蛋糕礼盒中收集重复的蛋糕来累积印花，或选购加速礼包立刻充值！`)
};

const zh_tw_dialog_not_enough_stamps_guide = /** @type {(inputs: Dialog_Not_Enough_Stamps_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`從蛋糕禮盒中收集重複的蛋糕，來累積更多印花。或選購加速禮包立刻加值！`)
};

/**
* | output |
* | --- |
* | "Open more cake boxes to earn stamps from duplicate cakes, or get the Boosting Pack for an instant top-up!" |
*
* @param {Dialog_Not_Enough_Stamps_GuideInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_not_enough_stamps_guide = /** @type {((inputs?: Dialog_Not_Enough_Stamps_GuideInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Not_Enough_Stamps_GuideInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_not_enough_stamps_guide(inputs)
	if (locale === "ar") return ar_dialog_not_enough_stamps_guide(inputs)
	if (locale === "de") return de_dialog_not_enough_stamps_guide(inputs)
	if (locale === "es") return es_dialog_not_enough_stamps_guide(inputs)
	if (locale === "fr") return fr_dialog_not_enough_stamps_guide(inputs)
	if (locale === "it") return it_dialog_not_enough_stamps_guide(inputs)
	if (locale === "ja") return ja_dialog_not_enough_stamps_guide(inputs)
	if (locale === "ko") return ko_dialog_not_enough_stamps_guide(inputs)
	if (locale === "pt_br") return pt_br_dialog_not_enough_stamps_guide(inputs)
	if (locale === "ru") return ru_dialog_not_enough_stamps_guide(inputs)
	if (locale === "th") return th_dialog_not_enough_stamps_guide(inputs)
	if (locale === "tr") return tr_dialog_not_enough_stamps_guide(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_not_enough_stamps_guide(inputs)
	return zh_tw_dialog_not_enough_stamps_guide(inputs)
});